import { Archive, BoxesIcon, Calendar, TagsIcon } from 'lucide-react'

import { Business, useScanState } from '../stores/scanStore'

const HouseBillCard: React.FC = () => {
  const { houseBill, activeBusiness } = useScanState()

  const getStatusBadgeStyle = () => {
    if (!houseBill) return 'bg-gray-100 text-gray-700'

    // 根据 activeBusiness 决定主题颜色
    if (activeBusiness === Business.DELIVERY) {
      return 'bg-orange-100 text-orange-700'
    }
    return 'bg-blue-100 text-blue-700'
  }

  const getCardStyle = () => {
    if (!houseBill) return 'bg-white border-gray-200'

    // 根据 activeBusiness 决定主题颜色
    if (activeBusiness === Business.DELIVERY) {
      return 'bg-orange-50 border-orange-300'
    }
    return 'bg-blue-50 border-blue-300'
  }

  return (
    <>
      {/* HBL 信息卡片 */}
      {houseBill && (
        <div className={`rounded-lg shadow-sm border-2 p-6 ${getCardStyle()}`}>
          <div className="flex justify-between items-start mb-4">
            <div className="space-y-2 flex-1">
              <div className="flex items-center space-x-3">
                <span className="font-semibold text-xl text-gray-900">
                  {houseBill.houseBlNumber}
                </span>
                <span
                  className={`px-2 py-1 text-xs rounded-full ${getStatusBadgeStyle()}`}
                >
                  {houseBill.statusDisplay}
                </span>
              </div>
              <div className="flex items-center text-sm text-gray-600">
                <Calendar className="w-4 h-4 mr-1" />
                <span>
                  预约搬出: {houseBill.scheduledOutboundDate || '未设置'}
                </span>
              </div>
              <div className="flex items-center text-sm text-gray-600">
                <Archive className="w-4 h-4 mr-1" />
                <span>托盘总数: {houseBill?.warehousePallets.length || 0}</span>
              </div>
              <div className="flex items-center text-sm text-gray-600">
                <TagsIcon className="w-4 h-4 mr-1" />
                <span>麦头总数: {houseBill?.marksNumbers?.length || 0}</span>
              </div>
              <div className="flex items-center text-sm text-gray-600">
                <BoxesIcon className="w-4 h-4 mr-1" />
                <span>箱货总数: {houseBill?.packages || 0}</span>
              </div>
            </div>
            {/* <div className="flex flex-col space-y-2">
              <button
                className="px-3 py-1.5 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded-lg transition-colors"
                onClick={clearHouseBill}
              >
                清除数据
              </button>
            </div> */}
          </div>
        </div>
      )}
    </>
  )
}

export default HouseBillCard
